// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/plugins/v1/variable_service.proto (package mochabugapis.adapt.plugins.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../../buf/validate/validate_pb";
import type { JTDSchema, JTDSchemaJson } from "../../graph/v1/jtd_schema_pb";
import { file_mochabugapis_adapt_graph_v1_jtd_schema } from "../../graph/v1/jtd_schema_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/plugins/v1/variable_service.proto.
 */
export const file_mochabugapis_adapt_plugins_v1_variable_service: GenFile = /*@__PURE__*/
  fileDesc("CjRtb2NoYWJ1Z2FwaXMvYWRhcHQvcGx1Z2lucy92MS92YXJpYWJsZV9zZXJ2aWNlLnByb3RvEh1tb2NoYWJ1Z2FwaXMuYWRhcHQucGx1Z2lucy52MSJtChJWYXJpYWJsZURlZmluaXRpb24SPgoGc2NoZW1hGAEgASgLMiYubW9jaGFidWdhcGlzLmFkYXB0LmdyYXBoLnYxLkpURFNjaGVtYUIGukgDyAEBEhEKCXBsYWludGV4dBgDIAEoCEoECAIQA2IGcHJvdG8z", [file_buf_validate_validate, file_mochabugapis_adapt_graph_v1_jtd_schema]);

/**
 * A definition of a JSON variable
 *
 * This message represents a variable used within the hosting platform.
 * Variables are essential for configuring applications and services hosted on the platform.
 * They store values that can be accessed by the application or service during runtime.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.VariableDefinition
 */
export type VariableDefinition = Message<"mochabugapis.adapt.plugins.v1.VariableDefinition"> & {
  /**
   * The schema that the variable must adhere to
   *
   * @generated from field: mochabugapis.adapt.graph.v1.JTDSchema schema = 1;
   */
  schema?: JTDSchema | undefined;

  /**
   * If true, the variable value is NOT treated as a secret.
   *
   * ## When plaintext = false (default):
   * - Values are encrypted at rest
   * - Values are treated as sensitive secrets
   *
   * ## When plaintext = true:
   * - Values are stored normally (not encrypted)
   * - Values are treated as non-sensitive data
   *
   * ## Use Cases for plaintext = false (default):
   * - API keys, access tokens, passwords
   * - Database connection strings with credentials
   * - Encryption keys, signing secrets
   * - OAuth client secrets
   * - Any credential material
   *
   * ## Use Cases for plaintext = true:
   * - Public configuration values
   * - Feature flags
   * - API endpoints (URLs without credentials)
   * - User IDs, tenant IDs, organization IDs
   * - Public identifiers
   *
   * ## Security Best Practices
   *
   * ALWAYS leave plaintext = false (default) for:
   * - Anything that grants access or authorization
   * - Anything that could be used to impersonate a user or service
   * - Any sensitive user-provided data
   *
   * Only set plaintext = true when the value contains non-sensitive
   * user-provided information.
   *
   * Default: false (variables are secrets by default)
   *
   * @generated from field: bool plaintext = 3;
   */
  plaintext: boolean;
};

/**
 * A definition of a JSON variable
 *
 * This message represents a variable used within the hosting platform.
 * Variables are essential for configuring applications and services hosted on the platform.
 * They store values that can be accessed by the application or service during runtime.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.VariableDefinition
 */
export type VariableDefinitionJson = {
  /**
   * The schema that the variable must adhere to
   *
   * @generated from field: mochabugapis.adapt.graph.v1.JTDSchema schema = 1;
   */
  schema?: JTDSchemaJson;

  /**
   * If true, the variable value is NOT treated as a secret.
   *
   * ## When plaintext = false (default):
   * - Values are encrypted at rest
   * - Values are treated as sensitive secrets
   *
   * ## When plaintext = true:
   * - Values are stored normally (not encrypted)
   * - Values are treated as non-sensitive data
   *
   * ## Use Cases for plaintext = false (default):
   * - API keys, access tokens, passwords
   * - Database connection strings with credentials
   * - Encryption keys, signing secrets
   * - OAuth client secrets
   * - Any credential material
   *
   * ## Use Cases for plaintext = true:
   * - Public configuration values
   * - Feature flags
   * - API endpoints (URLs without credentials)
   * - User IDs, tenant IDs, organization IDs
   * - Public identifiers
   *
   * ## Security Best Practices
   *
   * ALWAYS leave plaintext = false (default) for:
   * - Anything that grants access or authorization
   * - Anything that could be used to impersonate a user or service
   * - Any sensitive user-provided data
   *
   * Only set plaintext = true when the value contains non-sensitive
   * user-provided information.
   *
   * Default: false (variables are secrets by default)
   *
   * @generated from field: bool plaintext = 3;
   */
  plaintext?: boolean;
};

/**
 * Describes the message mochabugapis.adapt.plugins.v1.VariableDefinition.
 * Use `create(VariableDefinitionSchema)` to create a new message.
 */
export const VariableDefinitionSchema: GenMessage<VariableDefinition, {jsonType: VariableDefinitionJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_plugins_v1_variable_service, 0);

